import { EditOutlined, InfoCircleOutlined, MinusCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, message, Row, Select, Space, Upload } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import { fetchPackingModeList, resetPackingModeData } from '../../../slices/packing';
import { fetchAlloysList, resetAlloyList, resetCurrentAlloyListPage } from '../../../slices/alloy';
import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import { fetchSalesOrderById, updateSalesOrder } from '../../../slices/sales-order';

import moment from 'moment';


const { Option } = Select;

function EditSalesOrder() {

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { id } = useParams();
  const [btnLoading, setBtnLoading] = useState(false);

  const navigate = useNavigate();


  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const { list: alloyList, loading: alloyLoading, currentPage: alloyCurrentPage } = useSelector(state => state.alloy);
  const { list: temperList, loading: temperLoading, hasMore: temperHasMore } = useSelector(state => state.temper);

  const [poCopyList, setPoCopyList] = useState([]);


  useEffect(() => {
    const fetchSalesOrderDataById = async () => {
      try {
        const response = await dispatch(fetchSalesOrderById(id)).unwrap();
        if (response) {
          const responsedData = response?.data;

          form.setFieldsValue({
            customer_name: responsedData?.customer_name,
            order_date: dayjs(responsedData.order_date),
            purchase_order_number: responsedData.purchase_order_number || '',
            purchase_order_date: dayjs(responsedData.purchase_order_date),
            packing_mode: responsedData.packing_mode || '',
            remarks: responsedData.remarks || null,
            order_no: responsedData.order_no || '',
            sales_order_details:
              responsedData.inquiry_salesorder_details?.length > 0
                ? responsedData.inquiry_salesorder_details.map(detail => ({
                  id: detail.id || null,
                  section_no: detail.section_no,
                  alloy: detail.alloy,
                  temper: detail.temper,
                  length: detail.length || null,
                  pieces: detail.pieces || null,
                  quantity: detail.quantity || null,
                  conversion: detail?.conversion,
                  packing_cost: detail?.packing_cost,
                  surface_finish: detail.surface_finish,
                  cutting: detail.cutting || false,
                  cutting_price: detail.cutting_price || null,
                  machining: detail.machining || false,
                  machining_price: detail.machining_price || null,
                  deburring: detail.deburring || false,
                  deburring_price: detail.deburring_price || null,
                  anodising: detail.anodising || false,
                  anodising_description: detail.anodising_description || '',
                  anodising_price: detail.anodising_price || null,
                  powder_coating: detail.powder_coating || false,
                  powder_coating_description: detail.powder_coating_description || '',
                  powder_coating_price: detail.powder_coating_price || null,
                  pvdf: detail.pvdf || false,
                  pvdf_description: detail.pvdf_description || '',
                  pvdf_price: detail.pvdf_price || null,
                  out_source: detail.out_source != null ? detail.out_source : null,
                }))
                : [],
          });

          const sourceFiles = responsedData.purchase_order_copy
            ? [
              {
                uid: '-1', // Use a negative number for existing files
                name: responsedData.purchase_order_copy.split('/').pop(),
                url: responsedData.purchase_order_copy,
                status: 'done',
                thumbUrl: responsedData.purchase_order_copy,
              },
            ]
            : [];
          setPoCopyList(sourceFiles);
          form.setFieldsValue({ purchase_order_copy: sourceFiles });


        }
      } catch (error) {
        console.error('Error fetching work order:', error);
      }
    };
    fetchSalesOrderDataById();
  }, [id, form, dispatch]);



  useEffect(() => {
    dispatch(resetPackingModeData());
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetJobWorkList());
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    dispatch(fetchTempersList({ page: 1, pagesize: 1000 }))
    dispatch(fetchjobWorkList());
  }, [dispatch]);


  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      dispatch(resetTempersList());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTempersList({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };

  const handlePoCopyChange = (info) => {
    const newFileList = info.fileList.slice(-1).map(file => ({
      uid: file.uid,
      name: file.name,
      status: file.status,
      url: file.url || (file.originFileObj && URL.createObjectURL(file.originFileObj)),
      originFileObj: file.originFileObj,
    }));

    setPoCopyList(newFileList);
    // keep Form in sync
    form.setFieldsValue({ purchase_order_copy: newFileList });
  };

  // onRemove handler
  const handlePoCopyRemove = (file) => {
    // remove file from state
    const newList = poCopyList.filter(f => f.uid !== file.uid);
    setPoCopyList(newList);
    // update form field too
    form.setFieldsValue({ purchase_order_copy: newList });
    // return true to allow Upload to remove it
    return true;
  };

  const handleFinish = values => {
    setBtnLoading(true);
    const formattedOrderDate = dayjs(values.order_date).format('YYYY-MM-DD');

    const formattedPurchaseOrderDate = dayjs(values.purchase_order_date).format(
      'YYYY-MM-DD',
    );

    const basePayload = {

      order_date: formattedOrderDate,
      purchase_order_number: values.purchase_order_number,
      purchase_order_date: formattedPurchaseOrderDate,
      packing_mode: values.packing_mode,
      remarks: values.remarks,
      sales_order_details: values.sales_order_details?.map(detail => {
        const formattedDetail = {
          id: detail?.id || null,
          section_no: detail?.section_no,
          alloy: detail?.alloy,
          temper: detail?.temper,
          pieces: detail.pieces || null,
          quantity: detail.quantity || null,
          length: detail.length || null,
          surface_finish: Array.isArray(detail.surface_finish) ? detail.surface_finish : [],
          cutting: detail?.cutting || false,
          machining: detail?.machining || false,
          deburring: detail?.deburring || false,
          anodising: detail?.anodising || false,
          powder_coating: detail?.powder_coating || false,
          pvdf: detail?.pvdf || false,
          out_source: detail?.out_source,
          anodising_description: detail.anodising_description || '',
          anodising_price: parseFloat(detail.anodising_price) || null,
          powder_coating_description: detail.powder_coating_description || '',
          powder_coating_price: parseFloat(detail.powder_coating_price) || null,
          pvdf_description: detail.pvdf_description || '',
          pvdf_price: parseFloat(detail.pvdf_price) || null,
          cutting_price: parseFloat(detail.cutting_price) || null,
          machining_price: parseFloat(detail.machining_price) || null,
          deburring_price: parseFloat(detail.deburring_price) || null,
        };
        Object.keys(formattedDetail).forEach(key => {
          if (formattedDetail[key] === null) delete formattedDetail[key];
        });
        return formattedDetail;
      }),
    };
    const formData = new FormData();
    formData.append('data', JSON.stringify(basePayload));
    if (poCopyList && poCopyList.length > 0 && poCopyList[0].originFileObj) {
      formData.append('purchase_order_copy', poCopyList[0].originFileObj);
    }
    
    dispatch(updateSalesOrder({ id, values: formData }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Work Order Updated Successfully!');
          navigate(-1);
        }
      })
      .catch(error => {
        let displayMessage = '';
        if (typeof error === 'object') {
          displayMessage = Object.entries(error)
            .map(([key, value]) => `${key}: ${value.join(', ')}`)
            .join('\n');
          message.error(displayMessage);
        } else {
          message.error(
            `Error: ${error || 'Failed to update the work order.'}`,
          );
        }
      })
      .finally(() => {
        setBtnLoading(false);
      });
  };


  const [searchTemper, setSearchTemper] = useState('');
  const workOrderType = Form.useWatch('workorder_type', form);
  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Edit Sales Order</h2>
          <div className="bredcrumbwrp">
            <Link
              className="back"
              onClick={() => {
                navigate(-1);
              }}
            >
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/sales-order-list">Sales Order List</Link> },
                { title: 'Edit Sales Order' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="customer_name"
                  label="Customer"
                >
                  <Input placeholder="Enter Customer Name" readOnly />
                </Form.Item>
              </Col>

              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    defaultValue={moment()}
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                    disabled
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_number"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid purchase order no',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Purchase Order No"
                    disabled={workOrderType === 'Job Work'}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                    disabled={workOrderType === 'Job Work'}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="packing_mode"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select packing mode' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                  />
                </Form.Item>
                {Array.isArray(form.getFieldValue('packing_type')) &&
                  form.getFieldValue('packing_type').includes('Other') && (
                    <Form.Item
                      name="packing_type_other_reason"
                      label="Other Reason"
                      rules={[
                        {
                          required: true,
                          message: 'Please enter other packing mode',
                        },
                        {
                          pattern: /^[a-zA-Z0-9\s]+$/,
                          message: 'Should be alphanumeric and spaces only',
                        },
                      ]}
                    >
                      <Input
                        style={{ marginTop: '8px' }}
                        placeholder="Please enter other packing mode"
                        onChange={e => {
                          const value = e.target.value;
                          const formattedValue = value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());
                          form.setFieldsValue({
                            packing_type_other_reason: formattedValue,
                          });
                        }}
                      />
                    </Form.Item>
                  )}
              </Col>
              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    disabled={workOrderType === 'Job Work'}
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ remarks: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="purchase_order_copy"
                  label="Purchase Order Copy"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e?.fileList;
                  }}
                  rules={[
                    {
                      required: true,
                      message: 'Please upload purchase order copy file',
                    },
                    {
                      validator: (_, fileList) => {
                        if (!fileList || fileList.length === 0) return Promise.resolve();

                        const allowedExtensions = /\.(pdf|jpe?g|png)$/i;

                        for (let file of fileList) {
                          // Get filename from various possible sources
                          const fileName = file?.originFileObj?.name || file?.name || '';

                          if (!fileName || !allowedExtensions.test(fileName)) {
                            return Promise.reject(new Error("Only PDF, JPEG, JPG, or PNG files are allowed"));
                          }
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Upload
                    name="file"
                    listType="picture"
                    accept=".pdf,.jpeg,.jpg,.png"
                    maxCount={1}
                    beforeUpload={() => false}
                    showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }}
                    fileList={poCopyList}
                    onChange={handlePoCopyChange}
                    onRemove={handlePoCopyRemove}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <label className="filenote">Upload PDF, JPEG, JPG or PNG file</label>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection" hidden={workOrderType === 'Job Work'}>
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="sales_order_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <>

                      <Row
                        gutter={[24, 24]}
                        className="rowItem mx-0"
                        align="middle"
                        key={key}
                        wrap={false}
                        style={{ width: '100%' }}
                      >
                        <Col flex="auto">
                          <Row gutter={16} key={key}>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'section_no']}
                                label="Section Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select profile number',
                                  },
                                ]}
                              >
                                <Input readOnly />
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'alloy']}
                                label="Alloy"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select alloy',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Alloy"
                                  loading={alloyLoading}

                                  notFoundContent={
                                    alloyLoading ? 'Loading...' : 'No options'
                                  }


                                  disabled
                                  allowClear
                                  showSearch={true}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      alloyList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.color_code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'temper']}
                                label="Temper"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select temper',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Temper"
                                  loading={temperLoading}
                                  value={searchTemper}
                                  onPopupScroll={onScrollTemper}
                                  notFoundContent={
                                    temperLoading ? 'Loading...' : 'No options'
                                  }
                                  onSearch={handleSearchTemer}

                                  disabled
                                  allowClear
                                  showSearch={true}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      temperList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'length']}
                                label="Length (mm)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter length',
                                  },

                                ]}
                              >
                                <Input
                                  placeholder="0"
                                  maxLength={6}
                                  readOnly
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'pieces']}
                                label="Pieces"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter pieces',
                                  },
                                  {
                                    pattern: /^[1-9]\d{0,5}$/, // only allows numbers from 1 to 999999
                                    message:
                                      'Please enter pieces greater than 0',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0"

                                />
                              </Form.Item>
                            </Col>

                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'quantity']}
                                label="Quantity (kg)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter quantity',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0.0"
                                  readOnly
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={12} sm={8} xl={2}>
                              <Form.Item
                                {...restField}
                                name={[name, 'conversion']}
                                label="Conversion"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid Conversion',
                                  },
                                ]}
                              >
                                <Input placeholder="0.0" readOnly/>
                              </Form.Item>
                            </Col>

                            <Col xs={12} sm={8} xl={2}>
                              <Form.Item
                                {...restField}
                                name={[name, 'packing_cost']}
                                label="Packing Cost"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid Conversion',
                                  },
                                ]}
                              >
                                <Input placeholder="0.0"  readOnly/>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'surface_finish']}
                                label="Surface Finish"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select surface finish',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Surface Finish"
                                  mode="multiple"
                                  value={form.getFieldValue([
                                    'sales_order_details',
                                    name,
                                    'surface_finish',
                                  ])}
                                  allowClear
                                  disabled
                                  showSearch
                                  optionFilterProp="children"
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'surface_finish'],
                                      value,
                                    );

                                  }}
                                  loading={jobWorkLoading}
                                >
                                  {jobWorkLoading ? (
                                    <Option key="loading" disabled>
                                      Loading...
                                    </Option>
                                  ) : (
                                    jobWorkdata.map(item => (
                                      <Option key={item.id} value={item.id}>
                                        {item.name}
                                      </Option>
                                    ))
                                  )}
                                </AutoOpenSelect>

                              </Form.Item>
                            </Col>

                            <Form.Item
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.sales_order_details?.[index]?.surface_finish !==
                                currentValues.sales_order_details?.[index]?.surface_finish
                              }
                              noStyle
                            >
                              {({ getFieldValue }) => {
                                const selectedSurfaceFinish = getFieldValue(["sales_order_details", index, "surface_finish"]) || [];

                                const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                                // Example: show conditional field if Laser Marking selected
                                const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                                const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                                return (
                                  <>
                                    {/* --- Engineering Fields --- */}
                                    {hasEngineering && (
                                      <>
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.sales_order_details?.[index]?.cutting !== curr.sales_order_details?.[index]?.cutting ||
                                            prev.sales_order_details?.[index]?.machining !== curr.sales_order_details?.[index]?.machining ||
                                            prev.sales_order_details?.[index]?.deburring !== curr.sales_order_details?.[index]?.deburring
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const cutting = getFieldValue(['sales_order_details', index, 'cutting']);
                                            const machining = getFieldValue(['sales_order_details', index, 'machining']);
                                            const deburring = getFieldValue(['sales_order_details', index, 'deburring']);

                                            return (
                                              <>
                                                {cutting && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Cutting Price"
                                                      name={[name, 'cutting_price']}
                                                      rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                    >
                                                      <Input placeholder="0.0" readOnly/>
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {machining && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Machining Price"
                                                      name={[name, 'machining_price']}
                                                      rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                    >
                                                      <Input placeholder="0.0" readOnly/>
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {deburring && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Deburring Price"
                                                      name={[name, 'deburring_price']}
                                                      rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                    >
                                                      <Input placeholder="0.0" readOnly/>
                                                    </Form.Item>
                                                  </Col>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                    {/* --- Surface Treatment Fields --- */}
                                    {hasSurfaceTreatment && (
                                      <>
                                        {/* Nested conditional price fields */}
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.sales_order_details?.[index]?.anodising !== curr.sales_order_details?.[index]?.anodising ||
                                            prev.sales_order_details?.[index]?.powder_coating !== curr.sales_order_details?.[index]?.powder_coating ||
                                            prev.sales_order_details?.[index]?.pvdf !== curr.sales_order_details?.[index]?.pvdf
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const anodising = getFieldValue(["sales_order_details", index, "anodising"]);
                                            const powder_coating = getFieldValue(["sales_order_details", index, "powder_coating"]);
                                            const pvdf = getFieldValue(["sales_order_details", index, "pvdf"]);
                                            return (
                                              <>
                                                {anodising && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Price"
                                                      name={[name, "anodising_price"]}
                                                      rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Price" readOnly/>
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {powder_coating && (
                                                  <Col xs={12} md={8} xl={3}>

                                                    <Form.Item
                                                      label="Powder Coating Price"
                                                      name={[name, "powder_coating_price"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Price"  readOnly/>
                                                    </Form.Item>

                                                  </Col>
                                                )}

                                                {pvdf && (
                                                  <Col xs={12} md={8} xl={3}>

                                                    <Form.Item
                                                      label="PVDF Price"
                                                      name={[name, "pvdf_price"]}
                                                      rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Price" readOnly />
                                                    </Form.Item>

                                                  </Col>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                  </>
                                );
                              }}
                            </Form.Item>


                          </Row>
                        </Col>
                        <Col>
                          <div className="addwrp">
                            {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              />
                            )}
                          </div>
                        </Col>
                      </Row>
                    </>
                  ))}
                  {/* <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {
                            add();
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item> */}
                </>
              )}
            </Form.List>
          </div>
          {/* )} */}
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<EditOutlined />}
              loading={btnLoading}
            >
              Edit Sales Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default EditSalesOrder;
